export default {

  onActiveName(state, num)
  {
    state.activeName.activeName = num
  },

  onNavID(state, num)
  {
    state.NavID = num
  },

  onIsLb(state, num)
  {
    state.IsLb = num
  },

  treeSubmit(state, num)
  {
    state.Treeid = num
  },
  setTransParents(state, checkNode)
  {
    state.checkNode = checkNode
  },
  setMinedata(state, obj)
  {
    state.minedata.name = obj.name
    state.minedata.url = obj.url
    state.minedata.bool = obj.bool
    state.minedata.route = obj.route
  },
  
  searchtype(state, num)
  {
    state.searchtype = num
  },

  onMarktype(state, num)
  {
    state.Marktype = num
  },

  onMeasureNum(state, num)
  {
    state.MeasureNum = num
  },

  onPreviousYears(state, num)
  {
    state.PreviousYears = num
  },

  onMeetingid(state, num)
  {
    state.meetingid = num
  },

  onProcessid(state, num)
  {
    state.processid = num
  },

  onKyltMid(state, num)
  {
    state.kyltMid = num
  },
  onDwid(state, num)
  {
    state.dwid = num
  },
  onKyqtjid(state, num)
  {
    state.kyqtjid = num
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js